import React, {
  // useState,
  useEffect,
} from 'react';
import {
  // AppState,
  View,
} from 'react-native';

import {updateDataAtPath, useFirebaseData} from 'src/Utils/fireUtils';
import {useSelector, useDispatch} from 'react-redux';
import {saveUserLocation} from 'src/Redux/reducers/user_location.reducer';

import moment from 'moment';

import {updateNearbyGroups} from '../Redux/reducers/nearby.reducer';
import {apiUpdateUserInfo} from '../Utils/apiCalls';

import * as Location from 'expo-location';
import {calculateDistance} from '../Utils/distanceHelpers';
import {mmkvStorage} from '../Utils/mmkvStorage';
import {saveGroupPosition} from '../Utils/huntFunctions';

import {logAttributesForSentryCrashlytics} from '../Utils/fireUtils';
import {getReduxState} from '../Utils/helpers';

const LocationController = () => {
  console.log('LocationController render');
  const userId = useSelector((state) => state.user?.userId);
  const groupId = useSelector(
    (state) => state.user?.info?.currentHuntInfo?.groupId,
  );
  const dispatch = useDispatch();

  //if ios grab location on mount, if android then ask for permissions first
  //ask for the user hunt list

  const [status, requestPermission] = Location.useForegroundPermissions();

  useEffect(() => {
    logAttributesForSentryCrashlytics(
      'locationPermissionStatus',
      `${status?.status || ''}`,
    );
  }, [status]);

  //saving the position to the group objects
  const savePosition = (position, type) => {
    const currentPosition = getReduxState(['location', 'region']);

    // checking if position changed
    if (currentPosition?.latitude && position) {
      const distanceChange = calculateDistance(
        currentPosition?.latitude,
        currentPosition?.longitude,
        position?.coords?.latitude,
        position?.coords?.longitude,
        'FEET',
      );

      // this already checks to 100 feet
      if (groupId) {
        saveGroupPosition(position?.coords || {}, groupId);
      }

      if (distanceChange < 100) {
        return console.log('location update stopped', {distanceChange});
      } else {
        console.log('location update allowed 1');
      }
    } else {
      console.log('location update allowed 2');
    }

    console.log({currentPosition, position});

    dispatch(saveUserLocation(position));

    /// this is likely slowing it down A LOT
    mmkvStorage.set('position', JSON.stringify(position));
    console.log('the position was set, type' + type, {position});
    if (
      position &&
      position.coords &&
      position.coords.latitude &&
      position.coords.longitude
    ) {
      // likewise shouldn't be doing this calculation every position update...
      // probably should only happen on CDM
    }

    //// these writes may be part of what's draining battery
    /// do we need these every location update ??
    if (userId) {
      updateDataAtPath(`users/${userId}/position`, JSON.stringify(position));
      const {latitude, longitude} = position?.coords || {};
      apiUpdateUserInfo({
        latitude,
        longitude,
        userId: userId || 'error',
      });
    }
  };

  useEffect(() => {
    if (status?.status == 'granted') {
      console.log('already granted permission');
    } else {
      console.log('useForeGroundPermission, current status', status?.status);
      requestPermission()
        .then((requestResponse) => {
          console.log({requestResponse});
        })
        .catch((requestError) => {
          console.error({requestError});
        });
    }
  }, [status?.status]);

  useEffect(() => {
    console.log('location permission status', {status});
    const listenerNumber = 'LocationListener' + Math.random() + ':';
    var locationListener;
    if (status?.status == 'granted') {
      console.log('watchPositionAsync');
      Location.getCurrentPositionAsync({
        // Tracking options
        accuracy: Location.Accuracy.BestForNavigation,
        distanceInterval: 10,
      })
        .then((location) => {
          console.log(listenerNumber + 'location updated 1', {location});
          savePosition(location, 1);
        })
        .catch((getCurrentLocationError) => {
          console.log({getCurrentLocationError});
        });
      locationListener = Location.watchPositionAsync(
        {
          // Tracking options
          accuracy: Location.Accuracy.Balanced,
          distanceInterval: 10,
        },
        (location) => {
          console.log(listenerNumber + 'new location');

          console.log(listenerNumber + 'location updated 2', {location});
          savePosition(location, 2);
        },
      );
    }
    return async () => {
      locationListener = await locationListener;
      if (locationListener) {
        console.log(listenerNumber + ' Removed');
      }
      locationListener?.remove?.();
      // console.log({locationListener});
    };
  }, [status?.status]);

  console.log('LocationController', {userId, groupId, status});

  let veryRoundedRegion = useSelector(
    (state) => state.location.veryRoundedRegion,
  );
  const nearbyGroupPath = `nearbyGroups/${moment().format('YYYY-MM-DD')}/${
    veryRoundedRegion?.latitude
  },${veryRoundedRegion?.longitude}/`;
  console.log({nearbyGroupPath, veryRoundedRegion});
  const playTestState = useSelector((state) => state.app_info?.playTestState);

  // saving the nearby groups
  useFirebaseData(
    nearbyGroupPath,
    (nearbyGroupFirebaseData) => {
      dispatch(
        updateNearbyGroups(
          nearbyGroupFirebaseData ? Object.values(nearbyGroupFirebaseData) : [],
        ),
      );
    },
    null, // no order by
    null, // no order by
    false, // hide logs
    playTestState, // suppress if playtest
  );

  return <View />;
};

export default LocationController;
